module.exports = __webpack_public_path__ + "static/media/social.90ed3f9c.png";